export const SET_DASHBOARD_PENDING = 'SET_DASHBOARD_PENDING';
export const SET_DASHBOARD_DATA = 'SET_DASHBOARD_DATA';